import React, { useContext, useState } from 'react';
import { ConfigContext } from './ConfigContext';
import { useWindowSize } from '@react-hook/window-size';

const DEFAULT_STATE = {
    siderOpen: true
};

const BookLayoutContext = React.createContext(DEFAULT_STATE);
const BookLayoutContextConsumer = BookLayoutContext.Consumer;

// function getWindowSize() {
//     const { innerWidth, innerHeight } = window;
//     return { innerWidth, innerHeight };
// }

const BookLayoutContextProvider = ({ children }) => {

    //const [windowSize, setWindowSize] = useState(getWindowSize());
    const { clientConfig } = useContext(ConfigContext)

    // useEffect(() => {
    //     function handleWindowResize() {
    //         setWindowSize(getWindowSize());
    //     }
    //     window.addEventListener('resize', handleWindowResize);
    //     return () => {
    //         window.removeEventListener('resize', handleWindowResize);
    //     };
    // }, []);
    // const windowHeight = windowSize.innerHeight;
    // const windowWidth = windowSize.innerWidth;

    const [width, height] = useWindowSize();
    const windowRatio = width / height;
    const isSiderADrawer = width < 1400;

    const modelInfoExtended = clientConfig.model.showBirthDate || clientConfig.model.showAge || (clientConfig.model.customFields && clientConfig.model.customFields.length > 0)

    const [siderOpen, setSiderOpen] = useState(DEFAULT_STATE.siderOpen);
    const siderWidth = 420

    const getHeaderHeight = () => {
        if (modelInfoExtended) {
            return 160;
        }
        return 135;
    }

    const headerHeight = getHeaderHeight()

    const toggleSider = () => {
        setSiderOpen(!siderOpen);
    };

    return (
        <BookLayoutContext.Provider value={{
            siderOpen: siderOpen,
            toggleSider: toggleSider,
            siderWidth: siderWidth,
            siderAsDrawer: isSiderADrawer,
            headerHeight: headerHeight,
            windowHeight: height,
            windowWidth: width,
            windowRatio: windowRatio,
            modelInfoExtended: modelInfoExtended
        }}>
            {children}
        </BookLayoutContext.Provider>
    )
};

export { BookLayoutContext, BookLayoutContextProvider, BookLayoutContextConsumer };

